import PartnershipTable from './PartnershipTable';

export default PartnershipTable;
